/**
 * @file format.ts
 * @brief Date and money text for the Billing screens.
 *
 * @author DES
 * @date 17-10-2026
 */

import { env } from "@/shared/config/env";
import { formatMinor, parseVatLabelMode, vatSuffix } from "../planConfirm";
import { perMinute } from "../planCompare";

const DAY = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric" });

export function formatDay(v: string | null | undefined): string | null {
  if (!v) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : DAY.format(d);
}

/** The VAT wording switch (VITE_PRICE_VAT_LABEL), off by default. */
export const vatMode = parseVatLabelMode(env.priceVatLabel);

/** A price with the VAT wording when the switch is on. */
export function price(minor: number | null | undefined, currency: string): string {
  if (minor == null || !Number.isFinite(minor)) return "—";
  return `${formatMinor(minor, currency)}${vatSuffix(vatMode)}`;
}

/**
 * A per-minute rate: "1.2p / min", "50p / min", "£1.00 / min". Sub-unit rates
 * read in pence / cents and are never rounded (launch pricing has 1.2p,
 * BACKEND ADR-045, 18-10-2026).
 */
export function rate(minor: number | null | undefined, currency: string): string {
  if (minor == null || !Number.isFinite(minor)) return "—";
  const r = perMinute(minor, currency);
  return vatMode ? r.replace(" / min", `${vatSuffix(vatMode)} / min`) : r;
}
